<template>
  <div class="c-filter-bar__search" v-click-outside="closeSearch">
    <div
      class="c-filter-bar__label"
      :class="{ 'is-open': searchVisible }"
      @click="toggleSearchField"
    >
      <icon width="18" height="18" name="search"></icon>
      <span class="screen-reader-text" id="search-label">Search</span>
    </div>
    <div
      class="c-filter-bar__control"
      v-show="searchVisible"
      @click="focusSearchInput"
    >
      <input
        ref="searchInput"
        class="c-filter-bar__search-input"
        name="filter_search"
        id="filter_search"
        type="text"
        placeholder="Start typing..."
        v-model="searchQuery"
        @input="search"
        aria-labelledby="search-label"
      />
    </div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
import debounce from "lodash/debounce";
import querySearch from "@/mixins/querySearch";

export default {
  name: "filter-bar-search",

  props: ["resource", "action", "options"],

  mixins: [querySearch],

  data() {
    return {
      searchVisible: false,
    };
  },

  created () {
    if (this.searchQuery) {
      this.searchVisible = true;
    }
  },

  methods: {
    closeSearch() {
      if (!this.searchQuery) {
        this.searchVisible = false;
      }
    },

    toggleSearchField() {
      const vm = this;
      this.searchVisible = !this.searchVisible;
      this.$nextTick(() => {
        vm.focusSearchInput();
      });
    },

    focusSearchInput() {
      if (this.searchVisible) {
        this.$refs.searchInput.focus();
      } else {
        // this.searchQuery = null;
        this.$refs.searchInput.blur();
      }
    },

    search() {
      if (this.searchQuery.length === 0) {
        this.$store.dispatch(
          `${this.resource}/${this.action}`,
          this.compOptions
        );
        this.updateSearchQuery(null);
      }

      if (this.searchQuery.length >= 1) {
        this.doSearch();
      }
    },

    doSearch: debounce(function() {
      this.$store.dispatch(`${this.resource}/${this.action}`, this.compOptions);
      this.updateSearchQuery(this.searchQuery);
    }, 2000),
  },

  computed: {
    compOptions() {
      if (this.tabFilter) {
        return { ...this.options, tabFilter: this.tabFilter };
      }
      return this.options;
    },
    searchQuery: {
      get() {
        return this.$store.state[this.resource].filters.searchQuery;
      },
      set(value) {
        this.$store.commit(`${this.resource}/setSearchQuery`, value);
      },
    },

    tabFilter() {
      return this.$store.state[this.resource].tabFilter;
    },
  },

  directives: {
    ClickOutside,
  },
};
</script>

<style lang="scss">
.c-filter-bar__search {
  position: relative;
  &-input {
    border: none;
    @media screen and (min-width: 1024px) {
      // margin-left: 1em;
    }
    width: calc(100% - 0.5em);
    box-sizing: border-box;

    &:focus {
      outline: none;
    }

    @media (min-width: 768px) {
      max-width: 100px;
    }
  }

  .c-filter-bar__control {
    position: absolute;
    cursor: text;
    width: 100px;
    top: 52px;
    width: calc(100vw - 24px);
    left: -1px;
    background: white;
    border: 1px solid $colour-nhs-pale-grey;

    z-index: 20;

    @media screen and (min-width: 1024px) {
      position: relative;
      background: transparent;
      top: 0;
      border: 0;
      width: 300px;
      padding-right: 20px;
    }
  }

  .c-filter-bar__label {
    padding: 2px 1em;
    min-width: auto;

    &.is-open {
      border-bottom: 1px solid white;
      position: relative;
      z-index: 22;

      @media (min-width: 768px) {
        border-bottom: none;
      }
    }
  }
}
</style>
